import { render } from "./ButtonReturnSite.vue?vue&type=template&id=75fb7e72"
import script from "./ButtonReturnSite.vue?vue&type=script&lang=js"
export * from "./ButtonReturnSite.vue?vue&type=script&lang=js"

import "./ButtonReturnSite.vue?vue&type=style&index=0&id=75fb7e72&lang=css"

import exportComponent from "/builds/proximis/page_abonnement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__